module.exports = __webpack_public_path__ + "img/logo.a73f44c5.png";